module.exports = __webpack_public_path__ + "static/media/05A.04871530.png";